/**
 * Show/Hide Password functionality
 */
(function (Rayban, $) {

  Rayban.displayPassword = function(formSelector) {
    var isShow = false;
    var $showPwd = $('#show-password').val();
    var $hidePwd = $('#hide-password').val();
    var $userLoginFrom = $('#user_login_form');
    var $userLoginFromPswBtn = $userLoginFrom.find('.password-display--btn');
    var $loginPasswordField = $('.login-password-field');
    $userLoginFrom.find('.login-password-field').off('keyup').on('keyup', function () {
      if ($loginPasswordField.val().length) {
        $userLoginFromPswBtn.show();
      } else {
        $userLoginFromPswBtn.hide();
      }
    });
    var $targetForm = $(formSelector);
    var $targetFormPswBtn = $targetForm.find('.password-display--btn');
    var $targetFormLoginPasswordField = $targetForm.find('.login-password-field');
    var $targetFormLoginPasswordText = $targetForm.find('.password-display--text');
    $targetFormPswBtn.off("click").on('click', function () {
      if (isShow) {
        $targetFormLoginPasswordField.attr("type", "password");
        $targetFormLoginPasswordText.text($showPwd);
        isShow = false;
      } else {
        $targetFormLoginPasswordField.attr("type", "text")
        $targetFormLoginPasswordText.text($hidePwd);
        isShow = true;
      }
    });
  }
})(
  window.Rayban = window.Rayban || {},
  window.jQuery
);
